import React from 'react';

import {
  Link,
  Divider,
  StyledCard,
  MarginTop,
  LinkContain,
  ContentContain,
  registerCardStyle,
  RegisterContainer,
  LoadingContain
} from './components/Styled';

import ErrorDisplay from 'components/ErrorDisplay';
import RegisterStep from './components/RegisterStep';
import RegisterHeader from './components/RegisterHeader';
import RegisterSuccess from './components/RegisterSuccess';

import Theme from 'Theme';
import Text from 'components/Text';
import LoadingSpinner from 'components/LoadingSpinner';

export const Register = ({
  step,
  values,
  onNext,
  errors,
  onPrev,
  onLogin,
  errorSet,
  success,
  loading,
  onCardAdd,
  onRegister,
  errorClear,
  invitation,
  accountInvite,
  errorMessage,
  invitationError,
  onInviteRegister,
  onCreateAccount
}) => (
  <RegisterContainer>
    <StyledCard {...registerCardStyle}>
      <RegisterHeader step={step} />
      <ContentContain>
        {loading ? (
          <LoadingContain>
            <LoadingSpinner large inline />
            <MarginTop />
            <Text.Title color={Theme.brandColor}>
              Processing Registration...
            </Text.Title>
          </LoadingContain>
        ) : success ? (
          <RegisterSuccess />
        ) : (
          <RegisterStep
            step={step}
            onPrev={onPrev}
            values={values}
            onNext={onNext}
            errors={errors}
            success={success}
            errorSet={errorSet}
            onCardAdd={onCardAdd}
            onRegister={onRegister}
            invitation={invitation}
            errorClear={errorClear}
            accountInvite={accountInvite}
            invitationError={invitationError}
            onCreateAccount={onCreateAccount}
            onInviteRegister={onInviteRegister}
          />
        )}
        <ErrorDisplay message={errorMessage} />
        <LinkContain>
          <Divider />
          Already have an account?{' '}
          {!loading && (
            <Link href={'#'} onClick={onLogin}>
              Login Here
            </Link>
          )}
        </LinkContain>
      </ContentContain>
    </StyledCard>
  </RegisterContainer>
);

export default Register;
